module.exports = "/_next/static/images/frank-loeffler-4ed54e1773817196bc034eec1e36e8b5.jpg";